//import '../assets/css/styles.css';

import './js/main';
import './js/filters';
import './js/tabs';
import './js/numbers';
import './js/thermometer';

const configurator = document.querySelector('.configurator');
if (configurator) {
    import('./js/configurator').then(Configurator => {
        Configurator.default.init();
    }).catch(err => {
        console.error('Failed to load Configurator module:', err);
    });
}

const resellersMapElement = document.getElementById('mapContainer');
if (resellersMapElement) {
    import('./js/resellers').then(Resellers => {
        Resellers.default.init(resellersMapElement);
    }).catch(err => {
        console.error('Failed to load Resellers module:', err);
    });
}

const sectionSliders = document.querySelectorAll('.section-slider');
if (sectionSliders.length > 0) {
    import('./js/slider').then(Slider => {
        new Slider.default();
    }).catch(err => {
        console.error('Failed to load Slider module:', err);
    });
}

// menu link data attribute
document.querySelectorAll('ul.hover-scroll li > a').forEach(link => {
    if (!link.parentElement.getAttribute('data-text')) {
        link.parentElement.setAttribute('data-text', link.textContent.trim());
    }

});

// Custom cursor
options = {
    "outerStyle": "disable",
    "hoverEffect": "pointer-blur",
    "hoverItemMove": false,
    "defaultCursor": false,
    "outerWidth": 20,
    "outerHeight": 20
};
magicMouse(options);
const cursorPointer = document.getElementById('magicPointer');
if (document.querySelector('.section-slider')) {
    document.querySelector('.section-slider .swiper').addEventListener('mouseover', function() {
        cursorPointer.classList.add('pointer-slide');
    });
    document.querySelector('.section-slider .swiper').addEventListener('mouseout', function() {
        cursorPointer.classList.remove('pointer-slide');
    });
}
let imgLinks = document.querySelectorAll('.img-link-col');
imgLinks.forEach(link => {
    link.addEventListener('mouseover', function() {
        cursorPointer.classList.add('pointer-arrow');
    });
    link.addEventListener('mouseout', function() {
        cursorPointer.classList.remove('pointer-arrow');
    });
});


/* Leaflet map */
/*
const mapElement = document.getElementById('map');
if (mapElement) {
    import('./js/./Leafletmap').then(Map => {
        Map.Leafletmap.init(mapElement);
    }).catch(err => {
        console.error('Failed to load Map module:', err);
    });
}*/


/* testing */
/*const container = document.getElementById('zoomable');
const parent = container.parentElement;
if (container && parent) {
    let scale = 1, lastX = 0, lastY = 0, posX = 0, posY = 0, dragging = false;

    function clamp(val, min, max) {
        return Math.max(min, Math.min(max, val));
    }

    function getBounds() {
        const parentRect = parent.getBoundingClientRect();
        const width = container.offsetWidth * scale;
        const height = container.offsetHeight * scale;
        const minX = Math.min(0, parentRect.width - width);
        const maxX = 0;
        const minY = Math.min(0, parentRect.height - height);
        const maxY = 0;
        // If content is smaller, center it
        return {
            minX: width > parentRect.width ? minX : (parentRect.width - width) / 2,
            maxX: width > parentRect.width ? maxX : (parentRect.width - width) / 2,
            minY: height > parentRect.height ? minY : (parentRect.height - height) / 2,
            maxY: height > parentRect.height ? maxY : (parentRect.height - height) / 2
        };
    }

    function updateTransform() {
        const { minX, maxX, minY, maxY } = getBounds();
        posX = clamp(posX, minX, maxX);
        posY = clamp(posY, minY, maxY);
        container.style.transform = `translate(${posX}px, ${posY}px) scale(${scale})`;
    }

    container.addEventListener('mousedown', e => {
        dragging = true;
        lastX = e.clientX;
        lastY = e.clientY;
    });

    window.addEventListener('mousemove', e => {
        if (!dragging) return;
        posX += e.clientX - lastX;
        posY += e.clientY - lastY;
        lastX = e.clientX;
        lastY = e.clientY;
        updateTransform();
    });

    window.addEventListener('mouseup', () => dragging = false);

    container.addEventListener('wheel', e => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.1 : 0.1;
        const newScale = clamp(scale + delta, 1, 3);
        if (newScale !== scale) {
            const rect = container.getBoundingClientRect();
            const parentRect = parent.getBoundingClientRect();
            const mouseX = e.clientX - parentRect.left - rect.width / 2 - posX;
            const mouseY = e.clientY - parentRect.top - rect.height / 2 - posY;
            posX -= mouseX * (newScale - scale) / scale;
            posY -= mouseY * (newScale - scale) / scale;
            scale = newScale;
            updateTransform();
        }
    }, { passive: false });

    updateTransform();
}
*/



